import { render, staticRenderFns } from "./ArticlePriceRow.vue?vue&type=template&id=00b69852&scoped=true&"
import script from "./ArticlePriceRow.vue?vue&type=script&lang=js&"
export * from "./ArticlePriceRow.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePriceRow.vue?vue&type=style&index=0&id=00b69852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b69852",
  null
  
)

export default component.exports